<template>
  <div>
    <parent-course-form page="setting" />
  </div>
</template>

<script>
import ParentCourseForm from "./ParentCourseForm/index.vue";
export default {
	name: "Course",
	components: { ParentCourseForm },
};
</script>

<style scoped>
</style>
